<template>
  <div class="farerule-wrapper">
    <CModal
      :show.sync="isShow"
      :backdrop="backdrop"
      :closeOnBackdrop="closeOnBackdrop"
      :centered="centered"
      :size="size"
      :color="color"
            @update:show="onUpdateShow"

    >
      <template #header-wrapper>
        <div v-if="(status==1)" class="d-flex justify-content-center">
          <template>
            <CCardHeader v-show="isShowIcon" class="w-100">
              <div class="row">
                <CCol col="9" class="title-icon">
                  <strong>{{heading}}</strong>
                  <a @click="openExternalLink"><img src="@imgPath/img/svg/icons/external_link.svg" alt=""  v-c-tooltip.hover="{
                      content:$t('cTC.newTab')
                    }" class="c-pointer"></a>
                </CCol>
                <CCol col="3" class="d-flex justify-content-end align-item-center">
                  <a @click="buttonList[0].func"  class="c-pointer">
                    <img src="@imgPath/img/svg/icons/cross.svg" alt="">
                  </a>
                </CCol>
              </div>
<!--                  <div class="d-flex">-->
<!--                  <div class="t-title">-->
<!--                    <strong>{{heading}}</strong>-->
<!--                    <img src="@imgPath/img/svg/icons/external_link.svg" alt="" @click="openExternalLink" v-c-tooltip.hover="{-->
<!--                      content: `New Tab`-->
<!--                    }" class="c-pointer">-->
<!--                  </div>-->

<!--                  </div>-->
<!--              <CRow col="12">-->
<!--                <CCol col="9">-->

<!--                </CCol>-->
<!--                <CCol col="3">-->
<!--                  <a @click="openExternalLink">-->
<!--                    <CIcon-->
<!--                      class="w-100 justify-content-end"-->
<!--                      color="white"-->
<!--                      name="cil-chart-line"-->
<!--                      size="lg"-->
<!--                    />-->
<!--                  </a>-->
<!--                  &lt;!&ndash; target="_blank" :href="externalLink" &ndash;&gt;-->
<!--                </CCol>-->
<!--              </CRow>-->
            </CCardHeader>
          </template>
          <br />
          <br />
          <!-- </div> -->
        </div>
        <div v-else class="d-flex justify-content-center">
          <template>
            <!-- <div class="d-flex justify-content-center">
        <strong style="text-align: center" class="pre-formatted "> Terms & Conditions </strong></div>
            <br/>-->
          </template>
          <br />
          <br />
        </div>
      </template>

      <!-- <div class="d-flex justify-content-center"> -->
      <span style="text-align: center">{{desc}}</span>
      <!-- </div> -->
      <br />

      <div class="d-flex justify-content-end">
        {{nextLine}}
        <div v-if="slotFunct">
          <u>
            <a style="color:Blue;" @click="slotFunct">{{customSlot}}</a>
          </u>
        </div>
      </div>

      <template #footer-wrapper>
        <CCardBody class="d-flex justify-content-end">
          <div class="ml-auto"
                  v-for="(button,index) in buttonList"
                  :key="index"
                  xl

          >
            <CButton
                    @click="button.func"
                    :color="button.color"
                    aria-pressed="true"
            >{{button.name}}</CButton>
          </div>

        </CCardBody>
      </template>
    </CModal>
  </div>
</template>

<script>
// import BaseConfiguration from "../../config/base";
import { onOpenLink } from "../../util/util.js";
import { COMPONENT_NAME, PATHNAME } from "../../util/constants";
import { LOG_TYPE } from '../../config/API_DATA';
import Logger from '../../services/logger';
import BaseConfiguration from '../../config/base';

export default {
  name: COMPONENT_NAME.C_TC,

  props: {
    externalLink: null,
    show: {
      type: Boolean,
      default: false
    },
    customSlot: {
      type: String,
      default: null
    },
    slotFunct: {
      type: Function
    },
    backdrop: {
      type: Boolean,
      default: true
    },

    closeOnBackdrop: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "lg"
    },

    color: {
      type: String,
      default: "dark"
    },
    nextLine: {
      type: String,
      default: null
    },
    desc: {
      type: String,
      default: ""
    },
    heading: {
      type: String,
      default: ""
    },
    status: {
      type: Number,
      default: 0
    },
    isShowIcon: {
      type: Boolean,
      default: true
    },

    buttonList: {
      type: Array,
      default: [
        {
          name: null,
          func: {
            type: Function
          },
          color: {
            type: String,
            default: "primary"
          }
        }
      ]
    }
  },
     data: () => ({
     isShow:false
   }),
  watch: {
    show(val) {
      this.isShow = val;
    }
  },
  methods: {
      onUpdateShow(value) {
      try {
        if(BaseConfiguration.isDebug) console.log("onUpdateShow");
       this.$emit('updateShow')
  
      } catch (err) {
              let body = Logger.buildRequest(
                COMPONENT_NAME.C_TC,
                "error in onUpdateShow",
                err.toString(),
                "onUpdateShow",
                LOG_TYPE.ERROR
              );
              Logger.getResponse(body);
            }
        
      },
    //to open a link
    openExternalLink() {
      try {
        onOpenLink(this.externalLink);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_TC,
          "error while opening link",
          err.toString(),
          "openExternalLink",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },
  created() {
    this.isShow=this.show;
  }
};
</script>
<style scoped>
.header-color {
  background: green;
}
.icon-color {
  color: white;
}
</style>
